import DownloadIcon from '@mui/icons-material/Download'
import {Box, Button, Toolbar, Tooltip, Typography, useTheme} from '@mui/material'
import {AgGridReact} from 'ag-grid-react'
import dayjs from 'dayjs'
import * as ExcelJs from 'exceljs'
import {download, generateCsv, mkConfig} from "export-to-csv"
import {saveAs} from 'file-saver'
import {useEffect, useState} from 'react'
import {ActionsToolBar} from '../components/grid/ActionsToolbar'
import httpReq from '../services/httpReq'
import {useLocation, useNavigate} from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import ModalAddUser from '../components/modals/asiaUsers/ModalAddUser'
import ModalEditUser from '../components/modals/asiaUsers/ModalEditUser'
import useMobile from "../hooks/useMobile";

const UsersPage = () => {
    const isMobile = useMobile();
    const ToolBar = (props) => {
        let selectedRow = props.node.data;

        const editAction = () => {
            setRowToEdit(selectedRow)
            setIsModalEditOpen(true)
        };

        /*
            const viewAction = () => {
              setRowToView(selectedRow)
              setIsModalViewOpen(true)
            }


            const customActions = [
              {
                action: viewAction,
                disabled: false,
                icon: 'view',
                label: 'View user',
                tooltip: 'View user'
              }
            ];
            */

        const deleteAction = () => {
            setRowToDelete(selectedRow)
            setIsOpenDeleteDialog(true)
        };
        // hasEdit editAction={editAction}
        // hasDelete deleteAction={deleteAction}
        return <ActionsToolBar hasEdit editAction={editAction}/>;
    };
    const [colsLabel, setColumns] = useState([
        {
            field: 'completeName'
            , headerName: 'Complete name'
            , flex: 4
        },
        {headerName: 'Actions', cellRenderer: ToolBar, flex: !isMobile ? 1 : 2}
    ])
    const [rowsData, setRowsData] = useState([])
    const [rowToEdit, setRowToEdit] = useState(null)
    const [rowToView, setRowToView] = useState(null)
    const [rowToDelete, setRowToDelete] = useState(null)
    const [isModalAddOpen, setIsModalAddOpen] = useState(false)
    const [isModalEditOpen, setIsModalEditOpen] = useState(false)
    // const [isModalViewOpen, setIsModalViewOpen] = useState(false)
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false)
    const [isOpenSnackbar, setisOpenSnackbar] = useState(false)
    const [snackbarValues, setSnackbarValues] = useState({
        btnColor: '',
        color: '',
        closeAction: true,
        message: ''
    })
    const [userRolesList, setUserRolesList] = useState([])

    const getUsersList = async () => {
        const res = await httpReq('User/GetList', 'GET', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            setRowsData(res.responseData)
        }
    }

    const getUserRolesList = async () => {
        const res = await httpReq(`Profile/GetList`, 'GET', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            setUserRolesList(res.responseData)
        }
    }

    useEffect(() => {
        if (!isModalAddOpen) {
            getUsersList()
            getUserRolesList()
        }
    }, [isModalAddOpen])

    useEffect(() => {
        if (!isModalEditOpen) {
            getUsersList()
            getUserRolesList()
        }
    }, [isModalEditOpen])

    const downloadUsersList = async (downloadType) => {
        const today = dayjs(new Date()).format('YYYY-MM-DD HH:mm')
        if (downloadType === 'excel') {
            const workbook = new ExcelJs.Workbook()

            const worksheet = workbook.addWorksheet('Sheet1')
            const excelColumns = Object.keys(rowsData[0]).map(key => ({
                header: key.charAt(0).toUpperCase() + key.slice(1),
                key: key
            }))
            worksheet.columns = excelColumns

            rowsData.forEach(row => worksheet.addRow(row))

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            saveAs(blob, `users-list-${today}`)
        } else if (downloadType === 'csv') {
            const csvConfig = mkConfig({useKeysAsHeaders: true, filename: `users-list-${today}`});
            const mappedUsersList = [...rowsData].map(({profile, ...user}) => {
                return user
            })

            const csv = generateCsv(csvConfig)((mappedUsersList))
            download(csvConfig)(csv)

        } else {
            return;
        }
    }

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            <Toolbar sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography sx={{flex: 1, fontSize: 15, fontWeight: 700}}>User list</Typography>
                <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                    <Tooltip title="Add user">
                        <Button variant='contained' onClick={() => {
                            setIsModalAddOpen(true)
                        }}><AddIcon/></Button>
                    </Tooltip>
                    <Tooltip title="Download csv">
                        <Button disabled={rowsData.length <= 0} onClick={() => {
                            downloadUsersList('csv')
                        }} variant='contained'>
                            <DownloadIcon/>
                        </Button>
                    </Tooltip>
                </Box>
            </Toolbar>

            {!isOpenDeleteDialog &&
                <div style={{margin: 10, height: '100%'}}>
                    <AgGridReact
                        rowData={rowsData}
                        columnDefs={colsLabel}
                    />
                </div>
            }

            {isModalEditOpen &&
                <ModalEditUser userRolesList={userRolesList} setIsOpen={setIsModalEditOpen} isOpen={isModalEditOpen}
                               userToEdit={rowToEdit} isMobile={isMobile}/>}
            {isModalAddOpen &&
                <ModalAddUser userRolesList={userRolesList} setIsOpen={setIsModalAddOpen} isOpen={isModalAddOpen}
                              isMobile={isMobile}/>}
        </Box>
    )
}
export default UsersPage
